import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { defaultModules, materialGridModules, materialModules } from "../constants";
import { PageContentModule } from "../page-content/page-content.module";
import { InviteFormComponent } from "./invite-form/invite-form.component";
import { InviteListComponent } from "./invite-list/invite-list.conmponent";
import { InvitesRoutingModule } from "./invites-routing.module";

@NgModule({
    declarations: [
        InviteListComponent,
        InviteFormComponent
    ],
    imports: [
        CommonModule,
        defaultModules,
        materialModules,
        PageContentModule,
        InvitesRoutingModule,
        TranslateModule.forChild(),
        materialGridModules,
    ]
})
export class InviteModule {

}